export interface EventAnchor {
  i: string
  s: string
  d: string
}

export interface KELEvent {
  v: string
  t: string
  d: string
  i: string
  s: string
  p?: string
  k?: string[]
  kt?: string
  n?: string[]
  nt?: string
  a: EventAnchor[]
  b?: string[]
  bt?: string
}

/**
 * KERI Notification type interface
 *
 */
export interface Notification {
  i: string
  dt: string
  r: boolean
  a: { r: string; d?: string; m?: string }
}

/**
 * KERI Notification list interface
 *
 */
export interface NotificationList {
  start?: number
  end?: number
  total?: number
  notes: Notification[]
}

export interface LECredPayload {
  lei: string
  qviCredSaid: string
}

export interface OorCredPayload {
  lei: string
  personLegalName: string
  officialRole: string
  oorAuthCredSaid: string
}

export interface OorAuthCredPayload {
  oorRecipientAid: string
  lei: string
  personLegalName: string
  officialRole: string
  leCredSaid: string
}

export enum EcrIssuanceType {
  ISSUED_BY_QVI = 'issuedByQVI',
  ISSUED_BY_LE = 'issuedByLE'
}

export interface EcrCredPayload {
  lei: string
  personLegalName: string
  engagementContextRole: string
  ecrEdgeCredSaid: string
}

export interface EcrAuthCredPayload {
  ecrRecipientAid: string
  lei: string
  personLegalName: string
  engagementContextRole: string
  leCredSaid: string
}

export interface GroupMember {
  aid: string
  name?: string
  weightage: string | null
  weighted: boolean
  minSignersThreshold: number
  ends: {
    agent?: { [key: string]: string } | null
    witness?: { [key: string]: string } | null
  }
}
